var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "image-list"
  }, [_vm._l(_vm.images, function (img, index) {
    return _c('div', {
      key: index,
      staticClass: "image-box",
      style: {
        width: _vm.size,
        height: _vm.size
      }
    }, [_c('img', {
      style: {
        objectFit: _vm.fit
      },
      attrs: {
        "src": img,
        "alt": ""
      }
    }), _vm._v(" "), _vm.canPreview ? _c('div', {
      staticClass: "image-cover"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.handleView(img);
        }
      }
    })], 1) : _vm._e()]);
  }), _vm._v(" "), _c('div', [_c('Modal', {
    attrs: {
      "footer-hide": true,
      "mask": false,
      "styles": {
        top: '20px'
      }
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.currentImage
    }
  })])], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }